module.exports = __webpack_public_path__ + "img/menu_btn.a4802ff4.png";